<ion-content class="ion-padding">
    <app-autosave
        #autosave
        [hidden]="!canSaveReview"
        [isSaving]="autoSaving"
        [pendingChanges]="hasPendingChanges"
    ></app-autosave>

    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(reviewConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <ng-container
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration && (goals && !hasGoals(goals)) && !hideGoalsOnGoalsReview"
        >
            <ion-item lines="none" mode="ios" class="para-content">
                <ion-label class="ion-text-wrap">
                    <p class="para warning">
                        {{ 'goalsReview.goalsNotSetError' | translate }}
                    </p>
                </ion-label>
            </ion-item>
        </ng-container>

        <app-step-description
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration"
            [description]="getText(reviewConfig?.globalizationConfig, 'instructions' )"
        ></app-step-description>

        <ion-item lines="none" mode="ios" class="para-content">
            <div class="review-questions-wrapper">
                <form [formGroup]="coachingForm" *ngIf="coachingForm && (coachingConfig?.questionsGroups?.length > 0)">
                    <ng-container *ngFor="let group of coachingConfig?.questionsGroups | questionGroupAttributes: user?.attributes; let groupIndex = index">
                        <ng-container *ngIf="!questionsType[QuestionType.Calculate].hidden">
                            <h4> {{ (groupIndex + 1) + ' - ' + getText(group.globalizationConfig, 'title') }} </h4>
                        </ng-container>
                        <app-question-types
                            *ngFor="let question of group?.questions | questionAttribute: user.attributes:true"
                            [question]="question"
                            [formGroup]="coachingForm"
                        ></app-question-types>
                    </ng-container>
                </form>

                <form [formGroup]="coachingForm" *ngIf="coachingForm && !(coachingConfig.questionsGroups?.length > 0)">
                    <ng-container *ngFor="let question of coachingConfig?.questions | questionAttribute: user?.attributes; let index = index">
                        <ng-container *ngIf="!question.hideQuestion">
                            <h4> {{ (getVisibleQuestionIndex(question)) + ' - ' + getText(question.globalizationConfig, 'title') }} </h4>
                            <app-question-types
                                [question]="question"
                                [formGroup]="coachingForm"
                            ></app-question-types>

                            <br/>

                            <p class="rejectComment" *ngIf="coachingForm.get('field' + (question.currentIndex ?? question.order))?.value && 
                                       coachingForm.get('field' + (question.currentIndex ?? question.order) + 'Comment')?.value">
                                {{ coachingForm.get('field' + (question.currentIndex ?? question.order) + 'Comment')?.value }}
                            </p>
                        </ng-container>
                    </ng-container>
                </form>

                <ng-container *ngIf="coachingForm?.get('managerComment')?.value">
                    <div class="manager-comment-question-block">
                        <div class="manager-comment-text-type">
                            <p class="manager-comment-title">{{ 'goalsValidation.managerComment' | translate}}</p>
                            <ion-textarea
                                class="manager-comment-input"
                                autoGrow="true"
                                [disabled]="true"
                                [value]="coachingForm.get('managerComment')?.value"
                            ></ion-textarea>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ion-item>

        <ion-card
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration && !hideGoalsOnGoalsReview && !isUserAttributesInsideConsentGoals"
            mode="ios"
            class="card-table-data"
        >
            <h4 class="goals-review">{{ 'goalsReview.goalsReview' | translate }}</h4>
            <ion-card-header>
                <ion-searchbar
                    mode="ios"
                    class="section-search-custom"
                    [placeholder]="'generic.searchByName' | translate"
                    (keyup)="updateSearch($any($event).target.value)"
                ></ion-searchbar>
                <ng-container *ngIf="canAddGoal(goals)">
                    <ion-button
                        mode="ios"
                        color="secondary"
                        (click)="openManageGoalsInputModal()"
                    >
                        {{ 'goalsInput.newGoalBtn' | translate }}
                    </ion-button>
                </ng-container>
            </ion-card-header>

            <app-user-goals-list
                [goals]="displayedGoals"
                [goalsInputConfig]="inputConfig"
                [processType]="ProcessType.GoalsReview"
                [canEditGoals]="canEdit"
                [canDeleteGoal]="canEdit"
                [showValidatedBadge]="!canEdit"
                (edit)="openManageGoalsInputModal($event.goal)"
                (delete)="confirmDeleteGoal($event.goal)">
            </app-user-goals-list>
        </ion-card>

        <div class="bottom-buttons ion-text-right">
            <ng-container *ngIf="canSaveReview">
                <ion-button
                    mode="ios"
                    color="primary"
                    class="save"
                    (click)="saveClicked()"
                >
                    {{ 'generic.save' | translate }}
                </ion-button>
            </ng-container>
            <ng-container *ngIf="canSubmitGoals">
                <ion-button
                    mode="ios"
                    color="secondary"
                    class="send"
                    (click)="submitGoals(goals)"
                >
                    {{ 'goalsReview.sendGoalsBtn' | translate }}
                </ion-button>
            </ng-container>
        </div>
    </div>
</ion-content>
